import path from 'ramda/src/path'
import prop from 'ramda/src/prop'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import stepIdSelector from 'root/src/client/logic/form/selectors/stepIdSelector'
import previousRouteSelector from 'root/src/client/logic/project/selectors/previousRouteSelector'

export default (state, { submitIndex, moduleId, moduleKey, ...props }) => {
	const stepId = stepIdSelector(state, { moduleKey })
	const stepPath = stepId ? ['steps', stepId] : []
	const onSuccessRedirectSelector = path(
		[moduleId, ...stepPath, 'submits', submitIndex, 'onSuccessRedirectSelector'],
		moduleDescriptions,
	)

	if (onSuccessRedirectSelector) {
		const previousRoute = previousRouteSelector(state)
		const { routeId: previousRouteId, routeParams: previousRouteParams } = previousRoute
		const previousRecordId = prop('recordId', previousRouteParams)
		const { routeId, routeParams, query } = onSuccessRedirectSelector(state, {
			submitIndex,
			moduleKey,
			previousRouteId,
			previousRecordId,
			stepId,
			...props,
		})
		return { routeId, routeParams, query }
	}
	return undefined
}
